import React from 'react';
import { InView } from 'react-intersection-observer';
import LazyLoad from 'react-lazy-load';
import { Select, Theme } from '@meitu/saas-ui';
import { FontItem } from '../';

const { Option } = Select;
const { AppTheme } = Theme;

export interface IFontItemProps<T extends FontItem> {
    item: T;
    index: number;
    lazyLoadRenderKey: number;
    theme: any;
    onTrackShow?: (item: T) => void;
    onClick: (item: T) => void;
    onMouseEnter: (item: T) => void;
    style?: React.CSSProperties;
    keyPrefix?: string;
    isGroupChildren?: boolean;
    freeUseVipFont?: boolean;
}

// 单个字体项组件
const FontItemCom = <T extends FontItem>(props: IFontItemProps<T>) => {
    const {
        item,
        index,
        lazyLoadRenderKey,
        style,
        theme,
        onClick,
        onMouseEnter,
        keyPrefix = 'other',
        isGroupChildren = false,
        onTrackShow,
        freeUseVipFont = false,
    } = props;

    //  获取字体背景图
    const getFontImage = (item: T) => {
        const thumbnail = theme !== AppTheme.dark ? item?.thumbnail_text_dark : item?.thumbnail_text_white;

        return thumbnail || item.thumbnail;
    };

    return (
        <Option
            className="text-fontFamily__item"
            key={`${keyPrefix}__${item.material_id || index}`}
            value={item.font_name}
            label={item.name}
            data-track-id={item.id}
            data-track-vip={item.is_vip}
            data-track-type={item.type_id}
            style={style}
        >
            <InView as="div" threshold={1} triggerOnce onChange={(inView) => inView && onTrackShow?.(item)}>
                <div
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onClick(item);
                    }}
                    className="font-item-info"
                    style={{
                        marginLeft: isGroupChildren ? 16 : 0,
                    }}
                    onMouseEnter={() => onMouseEnter(item)}
                >
                    {/* 需要用lazyLoadRenderKey控制lazyLoad初始化时机, 不然展示有问题 */}
                    <LazyLoad key={lazyLoadRenderKey}>
                        <>
                            <img src={getFontImage(item)} className="font-image" alt="" />
                            {item.is_vip === '1' && !freeUseVipFont && (
                                <img className="corner-mark" src={item.corner_mark} alt="" />
                            )}
                        </>
                    </LazyLoad>
                </div>
            </InView>
        </Option>
    );
};

export default FontItemCom;
